import { createSelector } from 'reselect'
import featureScopesSelector from './featureScopesSelector'

const isTrampolineEnabledSelector = createSelector(
    featureScopesSelector,
    (featureScopes): boolean => featureScopes.includes('trampoline'),
)

export default isTrampolineEnabledSelector
